export default __webpack_public_path__ + "static/media/26.98850f85.jpg";